// src/features/planning/components/PlanningPeriodPicker.tsx
// ADR-092 Rule PLN-FE-05: a simple <select>, not EntityPicker (ADR-089)
// — period is a single-type FK, not a polymorphic binding target.
//
// ⚠️ Hook name useV1PlanningPeriodsList is inferred from the ADR-082
// naming pattern, not confirmed against a real orval output. Verify
// against api/generated/planning* after `npm run api:generate`.

import { useV1PlanningPeriodsList } from "@/api/generated/v1/v1";
import { extractResults } from "@/shared/utils/apiResponseUtils";

export interface PlanningPeriodPickerProps {
  value: string | null;
  onChange: (periodId: string) => void;
  disabled?: boolean;
}

export function PlanningPeriodPicker({
  value,
  onChange,
  disabled,
}: PlanningPeriodPickerProps) {
  const { data, isLoading } = useV1PlanningPeriodsList();
  const periods = extractResults<any>(data);

  return (
    <select
      data-testid="planning-period-picker"
      value={value ?? ""}
      disabled={disabled || isLoading}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="" disabled>
        {isLoading ? "در حال بارگذاری..." : "انتخاب بازهٔ زمانی"}
      </option>
      {periods.map((p: { id: string; code: string }) => (
        <option key={p.id} value={p.id}>
          {p.code}
        </option>
      ))}
    </select>
  );
}
